export default {"src":"/_next/static/media/bookkeeping.e5f206c2.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};